import { EmployeeActions, ErrorActions } from 'common/constants/actions';

const initialState = {
  employee_roles: [],
  pending: false,
  created: false,
};

export default function EmployeeRoles(state = initialState, action) {
  switch (action.type) {
    case EmployeeActions.ROLES.GET_ALL:
      return {
        ...state,
        employee_roles: action.payload,
        pending: false,
        created: false,
      };

    case EmployeeActions.ROLES.FETCH:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
        created: false,
      };

    case EmployeeActions.ROLES.EDIT:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
        created: false,
      };

    case EmployeeActions.ROLES.CLEAR:
      return {
        ...state,
        employee_roles: [],
        created: false,
      };

    case ErrorActions.CLEAR_ALL:
      return {
        ...state,
        employee_roles: [],
        created: false,
      };

    default:
      return state;
  }
}
